export const DOMAIN = window.location.hostname.replace(/^www\./, "");
export const BASE_URL = "https://shopapi.teleforce.cx/api/shop/v1";

export const LEAD_API = "https://platformapi.teleforce.cx/api/v1/api";